import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { FaTrashAlt, FaEdit, FaPlus } from 'react-icons/fa';
import ReactFlow, {
  addEdge,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  ReactFlowProvider,
  useReactFlow,
  BezierEdge,
} from 'reactflow';
import 'reactflow/dist/style.css';
import { nanoid } from 'nanoid';
import { Snackbar, Alert } from '@mui/material';  // Import Snackbar and Alert
import html2canvas from 'html2canvas';
// import { FaEdit, FaPlus } from 'react-icons/fa';

import AddressNode from '../Nodes/CheckForServiceNode/CheckForServiceNode';
import ChooseProductsNode from '../Nodes/ChooseProductsNode/ChooseProductsNode';
import ServiceSelectionNode from '../Nodes/ServiceSelectionNode/ServiceSelectionNode';
import PaymentNode from '../Nodes/PaymentNode/PaymentNode';
import ReviewCartNode from '../Nodes/ReviewCartNode/ReviewCartNode';
import CredentialsNode from '../Nodes/CredentialsNode/CredentialsNode';
import IfNode from '../Nodes/IfNode/IfNode';
import SelfSchedulingNode from '../Nodes/SelfSchedulingNode/SelfSchedulingNode';
import AddOnsNode from '../Nodes/AddOnsNode/AddOnsNode';
import AccountSignupNode from '../Nodes/AccountSetupNode/AccountSetupNode';
import OrderReceiptNode from '../Nodes/OrderReceiptNode/OrderReceiptNode';
import LandingPageNode from '../Nodes/LandingPageNode/LandingPageNode';
import GardenwallNode from '../Nodes/GardenwallNode/GardenwallNode';
/*import CardNode from '../Nodes/CardNode/CardNode';
import PortNode from '../Nodes/PortNode/PortNode';
import SplitterNode from '../Nodes/SplitterNode/SplitterNode';
import VirtualLayerNode from '../Nodes/VirtualLayerNode/VirtualLayerNode';
import SiteNode from '../Nodes/SiteNode/SiteNode';
import RackNode from '../Nodes/RackNode/RackNode';

import CircuitNode from '../Nodes/CircuitNode/CircuitNode';
import DeviceNode from '../Nodes/DeviceNode/DeviceNode';*/


import SidebarTabs from '../Sidebar/SidebarTabs';
import WorkflowTemplate from './WorkflowTemplate';

// Import Modals for AddressNode and ChooseProductsNode
import AddressServiceabilityModal from '../Nodes/CheckForServiceNode/AddressServiceabilityModal';
import ChooseProductModal from '../Nodes/ChooseProductsNode/ChooseProductModal';
import CommonNodeModal from '../Nodes/CommonNode/CommonNodeModal';
import Sidebar from './Sidebar';
import TestWorkflowButton from './TestWorkflowButton';
import GenerateSnippetButton from './GenerateSnippetButton';
import { useAuth } from '../../contexts/AuthContext';
import WorkflowTipPopup from './WorkflowTipPopup';
import CreateWorkflowPopup from './CreateWorkflowPopup';
import CustomSwitch from '../../shared/CustomSwitch/CustomSwitch';
import { CLIENT_NAME } from '../../constants/companyConfig';

// import axios from 'axios';

const nodeTypes = {
  checkForServiceNode: AddressNode,
  chooseProductsNode: ChooseProductsNode,
  serviceSelectionNode: ServiceSelectionNode,
  paymentNode: PaymentNode,
  reviewCartNode: ReviewCartNode,
  credentialsNode: CredentialsNode,
  ifNode: IfNode,
  selfSchedulingNode: SelfSchedulingNode,
  addOnsNode: AddOnsNode,
  accountSetupNode: AccountSignupNode,
  orderReceiptNode: OrderReceiptNode,
  landingPageNode: LandingPageNode,
  gardenwallNode: GardenwallNode,
  /*cardNode:CardNode,
  portNode:PortNode,
  splitterNode:SplitterNode,
  virtualLayerNode:VirtualLayerNode,
  siteNode:SiteNode,
  rackNode:RackNode,
  deviceNode:DeviceNode,
  circuitNode:CircuitNode,*/
};

function formatNodeType(nodeType) {
  // Step: Remove 'Node' from the end if it exists
  let trimmedString = nodeType.endsWith('Node') ? nodeType.slice(0, -4) : nodeType;
  // Split the string at uppercase letters and join with spaces
  // This regex matches positions before uppercase letters
  const formattedString = trimmedString
    .replace(/([A-Z])/g, ' $1') 
    .trim();

  return formattedString;
}

function Flow() {

  /* create to update */
  const [tempWorkflow, setTempWorkflow] = useState('');
  const [tempWorkflowId, setTempWorkflowId] = useState('');
  const [tempWorkflowStatus, setTempWorkflowStatus] = useState('');

  const location = useLocation();
  const navigate = useNavigate();
  //const workflowId = (location.state ? location.state.workflowId : ''); 
  const { workflowId } = useParams();
  // const workflowData = tempWorkflow || (location.state ? location.state.workflow : '');
  const isNewWorkflow = tempWorkflowStatus === false ? tempWorkflowStatus : (location.state ? location.state.isNewWorkflow : '');

  const [workflowData, setWorkflowData] = useState('');


  const [workflowName, setWorkflowName] = useState(location.state ? location.state.workflowName : `Workflow ${nanoid(4)}`);
  const [workflowDescription, setWorkflowDescription] = useState('');
  const [nodes, setNodes, onNodesChange] = useNodesState(workflowData.nodes || []); 
  const [edges, setEdges, onEdgesChange] = useEdgesState(workflowData.edges || []); 
  const [workflowStatus, setWorkflowStatus] = useState('');

  // console.log(nodes);

  const { project } = useReactFlow();

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [activeNode, setActiveNode] = useState(null);

  const [workflow_client, setWorkflowClient] = useState(CLIENT_NAME);
  const [filters, setFilters] = useState([]);
  
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [deleteType, setDeleteType] = useState('');

  const [isActive, setIsActive] = useState((workflowData.workflow_status === 'INACTIVE') ? false : true);

  const [imageUrl, setImageUrl] = useState(null);

  // const firstRender = useRef(true);
  const didMount = useRef(false);

  const reactFlowWrapperRef = useRef(null);
  
  const handleSwitch = (e) =>{
    e.stopPropagation();
    if(nodes.length !== 0){ 
      handleTakeSnapshot();
    }
    if(validateWorkflow()){
      handleSaveWorkflow('publish');
    }
  }

  const handleStatusChange = (e) => {
    setFilters((prev) => ({ ...prev, status: e.target.value }));
  };

  const handleCategoryChange = (e) => {
    setFilters((prev) => ({ ...prev, category: e.target.value }));
  };

  // delete
  const handleDelete = (id, type, e) => {
    e.stopPropagation(); // Prevent triggering the parent `onClick` event
    setShowConfirmation(true);
    setDeleteId(id);
    setDeleteType(type);
    
  };
  const confirmDelete = (e) => {
    e.stopPropagation();
    setShowConfirmation(false); // Hide the confirmation block
    setSnackbarSeverity('success');
    setSnackbarOpen(true);
    if (deleteType === 'node') {
      handleDeleteNode(deleteId);
      setSnackbarMessage(`Selected widget deleted successfully`);
    } else if (deleteType === 'edge') {
      handleDeleteEdge(deleteId);
      setSnackbarMessage(`Selected edge deleted successfully`);
    } else {
      console.warn(`Unknown deleteType: ${deleteType}`);
    }  
  };

  const cancelDelete = (e) => {
    e.stopPropagation();
    setShowConfirmation(false); // Hide the confirmation block
  };

  // const { token } = useAuth(); 
  const { token, handleLogout } = useAuth();

  const [highlight, setHeighlight] = useState(false);

  /* Node dependency validation on connection change */
  const handleOnConnect = (edge_new) => {
    // Log all edge changes
    
    const mergedEdges = [...edges, { id: `reactflow__edge-${edge_new.source}-${edge_new.target}`, ...edge_new }];
    // console.log(mergedEdges);
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
    /*if(!validateNodeSequence(mergedEdges)){
      return;
    }else */
    if(!validConnection(mergedEdges)){
      return;
    }else{
      setSnackbarOpen(false);
    }
    onConnect(edge_new);
    // handleSaveWorkflow('ACTIVE');
    /*setTimeout(() => {
      if(validateWorkflow()){
        handleSaveWorkflow('ACTIVE');
      }
    }, 1000);*/
    
    // handleSaveWorkflow();
    // console.log(edge_new);
    // Call the original onEdgesChange function to update state
  };

  const validConnection = (edges) => {
    // console.log(nodes);  // console.log(edges);
    if(edges.length == nodes.length){
      setSnackbarMessage('Wrong widget connection');
      return false;
    }
    else if(checkDuplicateEdges(edges)){
      setSnackbarMessage('Multiple connections in same widget');
      return false;
    }else if(!checkReverseConnections(edges)){
      setSnackbarMessage('Reverse connections detected');
      return false;
    }
    
    return true
  };
  const checkDuplicateEdges = (edges) => {
    const sourceCount = {};
    const targetCount = {};
  
    // Count occurrences of each source and target
    edges.forEach(edge => {
      sourceCount[edge.source] = (sourceCount[edge.source] || 0) + 1;
      targetCount[edge.target] = (targetCount[edge.target] || 0) + 1;
    });
  
    // Return true if any source or target appears more than once
    return Object.values(sourceCount).some(count => count > 1) || 
           Object.values(targetCount).some(count => count > 1);
  };

  const checkReverseConnections = (edges) => {
    const edgeSet = new Set();
  
    for (const edge of edges) {
      const normalEdge = `${edge.source}-${edge.target}`;
      const reversedEdge = `${edge.target}-${edge.source}`;
  
      // If the reversed version exists in the set, return false
      if (edgeSet.has(reversedEdge)) {
        return false;
      }
      // Store the normal edge in the set
      edgeSet.add(normalEdge);
    }
  
    return true; // No reverse connections found
  };
  
  

  /* handleOnNodesChange */
  const handleOnNodesChange = (det) => {
    /*if(det[0].type == "dimensions" && 'gardenwallNode' == nodes[nodes.length - 1].type){
      // console.log(det);
      console.log(nodes[nodes.length - 1].type);
      // if('gardenwallNode' == nodes[nodes.length - 1].type){
      //   return;
      // }
      return;
    }else{
      // onNodesChange(det);
    }*/
    
    onNodesChange(det);
    // console.log('node change');
    // didMount.current = true;
    // handleSaveWorkflow();
  };

  const [allowAutosave, setAllowAutosave] = useState(false);
  // var allowAutosave = false;
  setTimeout(() => {
    setAllowAutosave(true);
  }, 1000);

  useEffect(() => {
    if(allowAutosave && !isNewWorkflow){
       handleSaveWorkflow('');
      /*if(validateWorkflow()){
        handleSaveWorkflow('ACTIVE');
      }*/
    }
  }, [nodes.length, edges.length, filters.category, workflowName, workflowDescription]);

  useEffect(() => {
    // console.log(workflowId);
    const fetchWorkflows = async () => {
      if (!token) {
        handleLogout(); // If no token, force logout
        return;
      }
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/workflows/workflow/${workflowId}`, {
          headers: {
            Authorization: `${token}`,
          },
        });

        if (response.status === 200) {
          const data = await response.data;
          // setWorkflows(data);
          // console.log(data);
          setWorkflowData(data.workflow);
          setWorkflowName(data.workflow_name);
          setWorkflowDescription(data.workflow_description);
          setNodes(data.workflow.nodes);
          setEdges(data.workflow.edges);
          setFilters((prev) => ({ ...prev, category: data.workflow_category, status: data.workflow_status}));
          const status = (data.workflow_status === 'INACTIVE') ? false : true;
          setIsActive(status);
          setWorkflowStatus(data.portal_status);
          // setWorkflowClient(data.workflow_client);
        } else {
          console.error('Failed to fetch workflows');
          if (response?.status === 401) {
            handleLogout(); // If unauthorized, logout user
          }
        }
      } catch (error) {
        console.error('Error fetching workflows:', error);
        if (error.response?.status === 401) {
          handleLogout(); // If unauthorized, logout user
        }
      }
    };

    if (token) {
      fetchWorkflows();
    }
  }, [token, handleLogout, workflowId]);

  const heighlightNodes = (node) => {
    setHeighlight(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveNode(null);
  };

  const saveNodeData = (data) => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id === activeNode.id) {
          return {
            ...node,
            data: {
              ...node.data,
              ...data,
            },
          };
        }
        return node;
      })
    );
    closeModal();
  };

  // Handle connection between nodes
  const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), [setEdges]);

  // Handle adding new nodes from drag-and-drop
  const addNode = useCallback((nodeType, position) => {
    const id = nanoid();
    const newNode = {
      id,
      type: nodeType,
      position,
      data: { label: formatNodeType(nodeType)}, //`${nodeType.charAt(0).toUpperCase() + nodeType.slice(1)}` },
    };
    setNodes((nds) => nds.concat(newNode));
  }, [setNodes]);

  // Handle drag over for ReactFlow area
  const onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  };

  // Handle drop event to add nodes in ReactFlow
  const onDrop = (event) => {
    event.preventDefault();
    const nodeType = event.dataTransfer.getData('application/reactflow');
    const reactFlowBounds = event.target.getBoundingClientRect();
    const position = project({
      x: event.clientX - reactFlowBounds.left,
      y: event.clientY - reactFlowBounds.top,
    });
    addNode(nodeType, position);
  };

  // Handle node double click to open modal
  const onNodeDoubleClick = (event, node) => {
    if (node.type === 'checkForServiceNode' || node.type === 'chooseProductsNode') {
      setActiveNode(node);
      setModalOpen(false);
    }else {
      setActiveNode(node);
      setModalOpen(false);
    }
  };

  const hasDuplicateTypes = (nodes) => {
    const typeCounts = nodes.reduce((acc, node) => {
      acc[node.type] = (acc[node.type] || 0) + 1;
      return acc;
    }, {});
    return Object.values(typeCounts).some((count) => count > 1);
  };

  // Save workflow functionality (handles both new and existing workflows)
  const validateGraph = (nodes, edges) => {
    const nodeIds = new Set(nodes.map(node => node.id)); // All available node IDs
    const connectedNodes = new Set(); // Track connected nodes
    const edgeMap = new Map(); // Track duplicate edges
    const sourceCount = new Map(); // Count occurrences of each source
    const targetCount = new Map(); // Count occurrences of each target

    for (const edge of edges) {
        const { source, target } = edge;

        // ✅ 1. Ensure both source and target exist in the node list
        if (!nodeIds.has(source) || !nodeIds.has(target)) {
            setSnackbarMessage(`❌ Invalid edge: Source or Target widget is missing.`);
            return false;
        }

        // ✅ 2. Ensure each edge is unique (no duplicate connections)
        const edgeKey = `${source}->${target}`;
        if (edgeMap.has(edgeKey)) {
            setSnackbarMessage(`❌ Duplicate edge found!`);
            return false;
        }
        edgeMap.set(edgeKey, true);

        // ✅ 3. Track source and target node connections
        connectedNodes.add(source);
        connectedNodes.add(target);

        // ✅ 4. Check if a source node has multiple outgoing edges
        sourceCount.set(source, (sourceCount.get(source) || 0) + 1);
        if (sourceCount.get(source) > 1) {
            setSnackbarMessage(`❌ A widget has multiple outgoing edges!`);
            return false;
        }

        // ✅ 5. Check if a target node has multiple incoming edges
        targetCount.set(target, (targetCount.get(target) || 0) + 1);
        if (targetCount.get(target) > 1) {
            setSnackbarMessage(`❌ A widget has multiple incoming edges!`);
            return false;
        }
    }

    // ✅ 6. Ensure all nodes are connected by at least one edge
    for (const node of nodes) {
        if (!connectedNodes.has(node.id)) {
            setSnackbarMessage(`❌ Disconnected widget found: ${node.data.label}`);
            return false;
        }
    }
    // console.log("✅ Validation Passed: All nodes are correctly connected, and edges are valid.");
    return true;
  };

  const validateNodeSequence = (edges) => {
    const rules = [
      ['checkForServiceNode', 'chooseProductsNode'],
      ['chooseProductsNode', 'reviewCartNode'],
      ['reviewCartNode', 'paymentNode'],
      ['paymentNode', 'accountSetupNode'],
    ];
    const rules2 = [
      ['orderReceiptNode', 'accountSetupNode']
    ];
    // Map node IDs to their types
    const nodeMap = nodes.reduce((acc, node, key) => {
      acc[node.id] = node.type;
      return acc;
    }, {});

    // const nodeTitle = nodes.reduce((acc, node) => {
    //   acc[node.type] = node.data.label;
    //   return acc;
    // }, {});

    const nodeTitle = {
      checkForServiceNode: 'Check For Service Widget',
      chooseProductsNode: 'Choose Products Widget',
      paymentNode: 'Payment for the products subscriber selected',
      reviewCartNode: 'Review Cart Widget',
      accountSetupNode: 'Account Setup Widget',
      orderReceiptNode: 'Order Receipt Widget',
    };
  
    // Get the sequence of nodes based on edges
    // const nodeSequence = [];
    // const visited = new Set();
    
    const adjacencyList = {};
    const inDegree = {}; // Track incoming edges (dependencies)

    // Initialize structures
    Object.keys(nodeMap).forEach(nodeId => {
      adjacencyList[nodeId] = []; // Empty list for each node
      inDegree[nodeId] = 0; // Initially, no dependencies
    });
    // Fill adjacency list and track dependencies
    edges.forEach(({ source, target }) => {
      adjacencyList[source].push(target);
      inDegree[target] = (inDegree[target] || 0) + 1;
    });

    // Find nodes with no dependencies (inDegree = 0)
    const queue = Object.keys(inDegree).filter(nodeId => inDegree[nodeId] === 0);
    const nodeSequence = [];

    // Process nodes in dependency order (Topological Sorting)
    while (queue.length > 0) {
      const nodeId = queue.shift(); // Take the next node with no dependencies
      nodeSequence.push(nodeMap[nodeId]); // Add to the result sequence

      // Reduce dependencies for connected nodes
      adjacencyList[nodeId].forEach(dependentNode => {
        inDegree[dependentNode] -= 1;
        if (inDegree[dependentNode] === 0) {
          queue.push(dependentNode);
        }
      });
    }
    
    // Validate the sequence based on rules
    for (let [requiredNode, dependentNode] of rules) {
      const requiredIndex = nodeSequence.indexOf(requiredNode);
      const dependentIndex = nodeSequence.indexOf(dependentNode);
  
      // If dependent node exists, required node must come before it
      if (dependentIndex !== -1) {
        if (requiredIndex === -1 || requiredIndex > dependentIndex) {
          // console.log(requiredIndex, dependentIndex);
          setSnackbarMessage(`Node dependency rule violated: ${nodeTitle[requiredNode]} must appear before ${nodeTitle[dependentNode]}`);
          return false; // Invalid dependency
        }
      }
    }

    for (let [requiredNode, dependentNode] of rules2) {
      const requiredIndex = nodeSequence.indexOf(requiredNode);
      const dependentIndex = nodeSequence.indexOf(dependentNode);
      
      console.log(requiredIndex, dependentIndex);
      // If dependent node exists, required node must come before it
      if (dependentIndex !== -1) {
        if (requiredIndex === -1 || requiredIndex != (dependentIndex + 1)) {
          // console.log(requiredIndex, dependentIndex);
          setSnackbarMessage(`Node dependency rule violated: ${nodeTitle[requiredNode]} must appear after ${nodeTitle[dependentNode]}`);
          return false; // Invalid dependency
        }
      }
    }

    return true; // Sequence is valid
  };

  const validateWorkflow = () => {
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
    if(nodes.length == 0){ // || edges.length == 0){
      setSnackbarMessage('Please add widgets');
      return;
    }
    else if(hasDuplicateTypes(nodes)){
      setSnackbarMessage("Widgets shouldn't be repeated");
      return;
    }/*else if(nodes.length > 1 && edges.length != (nodes.length - 1)){
      console.log(edges.length, (nodes.length - 1));
      setSnackbarMessage('Please connect the widgets');
      return;
    }*/
    else if ((nodes.length > 1 && !validateGraph(nodes, edges))){
      return;
    }
    else if(!validateNodeSequence(edges)){
      return;
    }
    return true;
  };
    

  var canSave = true;
  const handleSaveWorkflow = async (wf_status) => {
    // console.log(canSave);
    if(!canSave){
      return;
    }

    canSave = false;
    // console.log(canSave);
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
    
    // console.log(filters.status);
    // if filters.status == ACTIVE then force validations
    if (!workflowName || workflowName.trim() === '') {
      setSnackbarMessage('Name and description are required');
      return; 
    } // workflowDescription
    else if (!workflowDescription || workflowDescription.trim() === '') {
      setSnackbarMessage('Name and description are required');
      return; 
    }
    /*else if(nodes.length == 0){ // || edges.length == 0){
      setSnackbarMessage('Please add widgets');
      return;
    }*/
    else if((filters.category == null || filters.category == '') && !isNewWorkflow){ // || edges.length == 0){
      setSnackbarMessage('Please select a category');
      return;
    }
    /*else if(!validateWorkflow()){
      return;
    }*/
    else{
      setSnackbarOpen(false);
    }
    // console.log(filters);
    let status = "INACTIVE";
    if(wf_status=='publish'){
      status = "ACTIVE";
    }
    const updatedWorkflow = {
      //id: workflowId,
      workflow_name: workflowName,
      workflow: {
        nodes,
        edges,
      },
      workflow_status: status, //filters.status, //wf_status || 'INACTIVE', //
      workflow_category: filters.category,
      workflow_client: workflow_client,
      workflow_description: workflowDescription,
      portal_status: wf_status || 'draft',
      // workflow_image: imageUrl,
    };

    try {
      const method = isNewWorkflow ? 'POST' : 'PUT'; 
      const url = isNewWorkflow
        ? `${process.env.REACT_APP_BASE_URL}/workflows/create`
        : `${process.env.REACT_APP_BASE_URL}/workflows/update/${workflowId}`;
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}` // Assuming you are using a Bearer token
        },
        body: JSON.stringify(updatedWorkflow)
      });

      if (response && response.ok) {
        const savedTxt = isNewWorkflow ? 'created' : 'updated';
        setSnackbarMessage('Workflow '+savedTxt+' successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        const data = await response.json()
        if(data.error){
          // alert(data.error);
          setSnackbarMessage(data.error); //'Error saving workflow.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
        else if (isNewWorkflow) {
          // navigate('/');
          // setTempWorkflow(data.workflow);
          // setTempWorkflowId(data.id);
          // setTempWorkflowStatus(false);
          navigate(`/workflow/${data.id}`, {
            state: {
              workflowId: data.id
            },
          });
        }else{
          setWorkflowData(data.workflow);
          const status = (data.workflow_status === 'INACTIVE') ? false : true;
          // console.log(data, status);
          setIsActive(status);
          setWorkflowStatus(data.portal_status);
          // setTempWorkflowId(data.id);
          // navigate('/');
          // console.log(workflowData);
        }
        canSave = true;
      } else {
        canSave = true;
        // console.log(response);
        setSnackbarMessage('Error saving workflow.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      canSave = true;
      setSnackbarMessage('Failed to save workflow.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  let workflowType = 'type1';
  if(nodes.length > 0){
    if ('gardenwallNode' == nodes[0].type) {
      workflowType = 'type2';
    }
  }

  // handlePublishTemplate
  const [publishedTemplate, setPublishedTemplate] = useState('');

  const handlePublishTemplate = (data) => {
    setPublishedTemplate(data); // Update the state with data from ChildOne
  };

  /* Delete node and edge */
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedEdge, setSelectedEdge] = useState(null);

  const [nodePosition, setNodePosition] = useState({ x: 0, y: 0 });
  const [edgePosition, setEdgePosition] = useState({ x: 0, y: 0 });

  const handleDeleteNode = useCallback((nodeId) => {
    setNodes((nds) => nds.filter((node) => node.id !== nodeId));
    setEdges((eds) => eds.filter((edge) => edge.source !== nodeId && edge.target !== nodeId));
    setSelectedNode(null);  setSelectedEdge(null); 
  }, [setNodes, setEdges]);
  
  const handleDeleteEdge = useCallback((edgeId) => {
    setEdges((eds) => eds.filter((edge) => edge.id !== edgeId));
    setSelectedNode(null);  setSelectedEdge(null); 
  }, [setEdges]);
  
  // Keyboard event listener to delete selected node/edge
  /*
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Delete' || event.key === 'Backspace') {
        if (selectedNode) {
          handleDeleteNode(selectedNode.id);
          setSelectedNode(null);
        } else if (selectedEdge) {
          handleDeleteEdge(selectedEdge.id);
          setSelectedEdge(null);
        }
      }
    };
  
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedNode, selectedEdge, handleDeleteNode, handleDeleteEdge]);
  */
  const onNodeClick = (_, node) => {
    const nodeElement = document.querySelector(`[data-id="${node.id}"]`);
    if (nodeElement) {
      const rect = nodeElement.getBoundingClientRect();
      // console.log(rect);
      // console.log(rect.left + rect.width/2);
      // setNodePosition({ x: rect.left , y: rect.top + window.scrollY });
      setNodePosition({ x: (rect.left + rect.width/2), y: rect.top + window.scrollY });
    }
    setSelectedNode(node);  //setSelectedNode(node);
    setSelectedEdge(null); // Reset edge selection when node is selected
  };
  
  const onEdgeClick = (_, edge) => {
    // console.log(edge);
    const edgeElement = document.querySelector(`[data-testid="rf__edge-${edge.id}"]`);
    if (edgeElement) {
      const pathElement = edgeElement.querySelector(".react-flow__edge-path");
      
      if (pathElement) {
        const pathLength = pathElement.getTotalLength();
        const midpoint = pathElement.getPointAtLength(pathLength / 2); // Midpoint of edge

        const rect = pathElement.getBoundingClientRect();
        setEdgePosition({ x: rect.left + window.scrollX + rect.width / 2 , y: rect.top + window.scrollY + rect.height / 2 });
        // setEdgePosition({
        //   x: midpoint.x + window.scrollX,
        //   y: midpoint.y + window.scrollY,
        // });
      }
    }
    setSelectedEdge(edge);
    setSelectedNode(null); // Reset node selection when edge is selected
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Backspace') {
        // console.log('Global: Backspace pressed');
        setSelectedNode(null);  setSelectedEdge(null); 
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
  
  // Add delete button in UI
  const renderDeleteButton = () => {
    if (selectedNode) {
      // console.log(selectedNode);
      return (
        <div>
          <button
            style={{
              position: 'fixed',
              top: `${nodePosition.y - 20}px`,  
              left: `${nodePosition.x*(1)}px`,
              padding: '8px 8px',
              backgroundColor: 'red',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              zIndex: 1000,
              // transform: `translate(${selectedNode.position.x + 0}px, ${selectedNode.position.y + 0}px)`,
            }}
            onClick={(e) => handleDelete(selectedNode.id, 'node', e)}
          >
            <div style={{ cursor: 'pointer', color: '#ffffff'}}>
              <FaTrashAlt />
            </div>
          </button>

          <button
            style={{
              position: 'fixed',
              top: `${nodePosition.y - 20}px`,  
              left: `${nodePosition.x + 100}px`,
              padding: '8px 8px',
              backgroundColor: 'red',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              zIndex: 1000,
              display:'none'
              // transform: `translate(${selectedNode.position.x + 0}px, ${selectedNode.position.y + 0}px)`,
            }}
            // onClick={()=>handleClick(selectedNode.id, selectedNode.type, isWfwNodeIdPresent, template)}
          >
            <div style={{ cursor: 'pointer', color: '#ffffff'}}>
              <FaEdit />
            </div>
          </button>
        </div>
      );
    }
    if (selectedEdge) {
      return (
        <button
          style={{
            position: 'fixed',
            top: `${edgePosition.y - 20}px`,  
            left: `${edgePosition.x}px`,
            padding: '8px 8px',
            backgroundColor: 'red',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            zIndex: 1000,
          }}
          onClick={(e) => handleDelete(selectedEdge.id, 'edge', e)}
        >
          <div style={{ cursor: 'pointer', color: '#ffffff'}}>
            <FaTrashAlt />
          </div>
        </button>
      );
    }
    return null;
  };

  const handlePaneClick = () => {
    setSelectedNode(null);  setSelectedEdge(null);
  }
  

  const renderFlowContent = () => {
    // console.log(nodes[0].type);
    const edgesWithArrows = edges.map(edge => ({
      ...edge,
      // type: "smoothstep", // Makes the edges curved
      markerEnd: {
        type: "arrowclosed",
        width: 20, // Adjust width for a better arrow look
        height: 20,
        color: "#888", // Adjust color to match your design
      },
      style: { strokeWidth: 1, stroke: "#888" },
      /*markerEnd: { type: "arrowclosed" },  // Ensure arrows are rendered
      style: { strokeWidth: 1, stroke: "#222" } // Customize edge appearance*/
    }));

    /*markerEnd: { type: "arrowclosed" }, // This ensures the arrow is added
    animated: true, // Optional: makes the edge animated
    style: { strokeWidth: 2, stroke: "black" }*/
    
    if(workflowType){
      switch (workflowType) {
        case 'type2':
          return <WorkflowTemplate workflowType={workflowType} status={isNewWorkflow} />;
        default:
          return (
            <div ref={reactFlowWrapperRef} style={{ height: '100vh', width: '100%' }} >
            <ReactFlow 
              nodes={nodes}
              edges={edgesWithArrows}
              onNodesChange={handleOnNodesChange} // onNodesChange
              onEdgesChange={onEdgesChange}
              onConnect={handleOnConnect}  //onConnect
              // edgeTypes={{custom:<BezierEdge markerEnd="url(./images/close.svg)" />}}
              onNodeDoubleClick={onNodeDoubleClick}
              onNodeClick={onNodeClick}
              onEdgeClick={onEdgeClick}
              onPaneClick={handlePaneClick}
              onMoveEnd={handlePaneClick}
              fitView
              nodeTypes={nodeTypes}
            >
              <MiniMap />
              <Controls />
              <Background variant="dots" gap={12} size={1} />
              {renderDeleteButton()}
            </ReactFlow>
            </div>
          );
      }
    }
  };

  // Auto save autosave
  const handleWorkflowNameChange = (name) => {
    setWorkflowName(name);
    // didMount.current = true;
    handleSaveWorkflow('');
  };
  
  const handleWorkflowDescriptionChange = (description) => {
    setWorkflowDescription(description);
    // didMount.current = true;
    handleSaveWorkflow('');
  };
  
  const handleCategoryChangeWrapper = (e) => {
    // handleCategoryChange(category);
    // didMount.current = true;
    //setFilters((prev) => ({ ...prev, category: e?.target?.value }));
    setFilters((prev) => ({ ...prev, category: e }));
    // handleSaveWorkflow('');
  };

  /*
  useEffect(() => {
    // console.log(didMount.current);
    if (didMount.current) {
      // console.log('saved');
      if (workflowName || workflowDescription || filters.category) {
        const timeout = setTimeout(() => {
          // console.log(filters);
          handleSaveWorkflow();
        }, 500); // debounce saving to avoid excessive API calls
        return () => clearTimeout(timeout); // cleanup for debounce
      }
    }
    else {
      //didMount.current = didMount.current + 1; // skip first run
    }
  }, [workflowName, workflowDescription, filters, nodes, edges]);
  */

  /* create workflow popup */
  const [open, setOpen] = useState(true);
  /*
  const handleContinue = (data) => {
    console.log("Workflow submitted:", data);
  };
  */

  /* snapshot */
  // const { fitView } = useReactFlow();
  const handleTakeSnapshot = async () => {
    
    //project({ padding: 0.3 }); // optional: add a little margin
    // project({ x: 0, y: 0, zoom: 0.5 }, { duration: 300 });
    // await new Promise((resolve) => setTimeout(resolve, 300));

    if (reactFlowWrapperRef.current) {
      const canvas = await html2canvas(reactFlowWrapperRef.current);
      canvas.toBlob(async (blob) => {
        if (blob) {
          const file = new File([blob], 'flow-snapshot.png', { type: 'image/png' });
          
          // Upload to server
          await uploadImage(file);
          const previewUrl = URL.createObjectURL(blob);
          // setImageUrl(previewUrl);
          // console.log(blob);
        }
      });
    }
  };

  const uploadImage = async (file: File) => {
    const metaPayload = {
      wfwId: workflowId, //'939eb094-a09b-4ddd-885c-5c749f68bbe5',
      companyId: '255',
      type: 'image',
      contentType: 'image/png',
      purpose: 'workflow_image',
    };
    // console.log(file);
    try {
      // Step 1: Get presigned upload URL
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/workflows/upload/url`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`,
          'Accept': 'application/json',
        },
        body: JSON.stringify(metaPayload),
      });
  
      const { uploadUrl } = await res.json(); // This should return the presigned URL
      if (!uploadUrl) throw new Error('Upload URL not received');
  
      // Step 2: Upload the image to the presigned URL
      const uploadRes = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'image/png',
        },
        body: file,
      });
  
      if (!uploadRes.ok) {
        throw new Error('Image upload failed');
      }else{
        fetchImageUrl();
      }
  
      console.log('Image uploaded successfully');
    } catch (error) {
      console.error('Snapshot upload error:', error);
    }
  };

  
  const fetchImageUrl = async () => {
    try {
      const params = new URLSearchParams({
        wfwId: workflowId,
        companyId: '255',
        type: 'image',
        purpose: 'workflow_image',
      });

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/workflows/download/url?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `${token}`,
        },
      });

      const data = await response.json();
      if (data.downloadUrl) {
        setImageUrl(data.downloadUrl);
      } else {
        console.error('No image URL returned');
      }
    } catch (error) {
      console.error('Error fetching image URL:', error);
    }
  };


  return (
    <div style={{ display: 'flex', height: '100vh', position: 'relative' }}>
      {/* Sidebar Component */}
      {/* <Sidebar 
        isnewworkflow={isNewWorkflow} 
        workflowid={workflowId} 
        workflow={workflowData} 
        nodes={nodes} 
        workflowName={workflowName} 
        workflowType={workflowType}
        handlePublishTemplate={handlePublishTemplate}
        highlight={highlight}
        setWorkflowName={setWorkflowName}
        workflowDescription={workflowDescription}
        setWorkflowDescription={setWorkflowDescription}
        handleStatusChange={handleStatusChange}
        filters={filters}
        handleCategoryChange={handleCategoryChange}
         /> */}
      
      <Sidebar 
          isnewworkflow={isNewWorkflow} 
          workflowid={workflowId} 
          workflow={workflowData} 
          nodes={nodes} 
          workflowName={workflowName} 
          workflowType={workflowType}
          handlePublishTemplate={handlePublishTemplate}
          highlight={highlight}
          setWorkflowName={handleWorkflowNameChange}  // Wrapped function
          workflowDescription={workflowDescription}
          setWorkflowDescription={handleWorkflowDescriptionChange}  // Wrapped function
          handleStatusChange={handleStatusChange}
          filters={filters}
          handleCategoryChange={handleCategoryChangeWrapper}  // Wrapped function
          status={workflowStatus}
      />

      {/* {imageUrl ? (
        <img src={imageUrl} alt="Workflow Snapshot" style={{ maxWidth: '100%', height: 'auto' }} />
      ) : (
        <p>Loading image...</p>
      )} */}
      
      {/* React Flow Area */}
      <div
        style={{ flexGrow: 1, position: 'relative' }}
        onDrop={onDrop}
        onDragOver={onDragOver}
      >
        {/* Workflow Name */}
        <div style={{ position: 'absolute', top: '10px', left: '50%', transform: 'translateX(-50%)', zIndex: 1000, display: 'none', gap:'10px'  }}>
          <input
            type="text"
            value={workflowName}
            onChange={(e) => setWorkflowName(e.target.value)}
            style={{
              padding: '8px',
              fontSize: '16px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              width: '250px',
              textAlign: 'center',
            }}
          />
          {/* {console.log(filters)} */}
          <div style={{ display: 'flex', gap:'10px' }}>
              <select onChange={handleStatusChange} value={filters.status}  style={{ padding: '8px', borderRadius: '4px' }}>
                  <option value="">All Status</option>
                  <option value="ACTIVE">Active</option>
                  <option value="INACTIVE">Inactive</option>
              </select>
              <select onChange={handleCategoryChange} value={filters.category}  style={{ padding: '8px', borderRadius: '4px' }}>
                  <option value="">All Categories</option>
                  <option value="pre-registration">Pre Registration</option>
                  <option value="self-service-signup">Self service signup</option>
                  <option value="gardenwall">Gardenwall</option>
                  <option value="mdu">Multi dweling unit</option>
              </select>
          </div>
        </div>
        
        {renderFlowContent()} 

        {showConfirmation && (
          <div
          className='delete-block'  
          style={{
              position: 'absolute',
              top: '50%',
              left: '0',
              right: '0',
              transform: 'translate(0, -50%)',
              backgroundColor: 'white',
              padding: '15px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)',
              borderRadius: '8px',
              zIndex: 1000,
              width:'300px',
              margin:'auto'
            }}
          >
            <p>Are you sure you want to delete this item?</p>
            <button 
              onClick={confirmDelete} 
              style={{
                backgroundColor: '#dc3545',
                color: '#fff',
                border: 'none',
                padding: '3px 12px',
                borderRadius: '3px',
                cursor: 'pointer',
                marginRight: '10px',
                fontWeight: 'bold',
                transition: 'background-color 0.3s ease',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#c82333')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#dc3545')} 
              >
              Yes
            </button>
            <button 
              onClick={cancelDelete}
              style={{
                backgroundColor: '#6c757d',
                color: '#fff',
                border: 'none',
                padding: '3px 12px',
                borderRadius: '3px',
                cursor: 'pointer',
                fontWeight: 'bold',
                transition: 'background-color 0.3s ease',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#5a6268')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#6c757d')}
            >
              No
              </button>
          </div>
        )}

        {/* Test Workflow Button */}
        {!isNewWorkflow && (workflowType == 'type1') && (
            <TestWorkflowButton 
            setSnackbarMessage={setSnackbarMessage}
            setSnackbarSeverity={setSnackbarSeverity}
            setSnackbarOpen={setSnackbarOpen} 
            workflowId={workflowId}
            publishedTemplate={publishedTemplate}
            currentnodes={nodes.length}
            nodes={workflowData?.nodes?.length}
            heighlightNodes={heighlightNodes}
            />
        )}
        
        
        {/* <GenerateSnippetButton workflowId={workflowId} /> */}

        {/* Publish Workflow Button */ }
        {(!workflowStatus || (workflowStatus != 'publish')) && (
          <>
          {/* {console.log(workflowStatus)} */}
        <button
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            padding: '8px 16px',
            backgroundColor: 'var(--primary-color)',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            zIndex: 1000,
          }}
          onClick={handleSwitch}
        >
          Publish
        </button>
        </>
        )}
        {/* <button
          style={{
            position: 'absolute',
            top: '20px',
            right: '120px',
            padding: '8px 16px',
            backgroundColor: 'var(--primary-color)',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            zIndex: 1000,
          }}
        onClick={handleTakeSnapshot}>Take Snapshot</button> */}

        {/* <div onClick={handleSwitch} className='custom-switch' >
          {isActive ? 'Active' : 'Deactivated'}
          <CustomSwitch checked={isActive} onChange={()=>{}} />
        </div> */}
      </div>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

       {/* Create workflow  */ }
       {isNewWorkflow && (
        <CreateWorkflowPopup 
          open={open} 
          onClose={() => setOpen(false)} 
          onContinue={()=>handleSaveWorkflow('')} 
          setWorkflowName={setWorkflowName} 
          setWorkflowDescription={setWorkflowDescription}
          workflowName={workflowName}
          workflowDescription={workflowDescription}
          />
       )}

       {/* how to pop up  */ }
       {isNewWorkflow || (workflowDescription!='' && nodes.length==0) && ( 
        <WorkflowTipPopup />
       )}
      

      {/* Modals */}
      {modalOpen && activeNode && (activeNode.type === 'checkForServiceNode' || activeNode.type === 'chooseProductsNode') && (
        activeNode.type === 'checkForServiceNode' ? (
          <AddressServiceabilityModal
            isOpen={modalOpen}
            onClose={closeModal}
            nodeData={activeNode}
            onSave={saveNodeData}
          />
        ) : (
          <ChooseProductModal
            isOpen={modalOpen}
            onClose={closeModal}
            nodeData={activeNode}
            onSave={saveNodeData}
          />
        )
      )}

      {/* Common Modal for other node types */}
      {modalOpen && activeNode && activeNode.type !== 'checkForServiceNode' && activeNode.type !== 'chooseProductsNode' && (
        <CommonNodeModal
          isOpen={modalOpen}
          onClose={closeModal}
          nodeData={activeNode}
          onSave={saveNodeData}
          workflowId={workflowId}
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          width: '280px',
          backgroundColor: '#f0f1f5',
          padding: '10px',
          boxSizing: 'border-box',
          position: 'relative',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          borderRadius: '8px',
          marginRight: '10px',
          overflow: 'visible',
        }}
      >
        <SidebarTabs setActiveWorkflow={() => {}} nodes={nodes} />
      </div>
    </div>
  );
}

export default function FlowWrapper() {
  return (
    <ReactFlowProvider>
      <Flow />
    </ReactFlowProvider>
  );
}
